// css themes
export const cssThemes = {
	primary: 'primary',
	accent: 'accent',
	warn: 'warn',
};
